// extracted by mini-css-extract-plugin
export var wave = "Wave-module--wave--36hzw";
export var waveSvgTop = "Wave-module--waveSvgTop--1A3P-";
export var waveSvg = "Wave-module--waveSvg--17_WP";
export var hasWaveMobile = "Wave-module--has-wave-mobile--235gK";
export var hasWaveTablet = "Wave-module--has-wave-tablet--3qX3C";
export var hasWaveDesktop = "Wave-module--has-wave-desktop--3w9Ob";
export var spinAround = "Wave-module--spinAround--8gKp5";